import React, { useEffect, useState } from "react";
import styled from "styled-components";

import CustomModal from "shared/components/CustomModal";
import * as S from "@styled";
import Select from "shared/components/select/Select";
import { Option } from "shared/model/Option";

import { AppContext } from "../../App";
import { ProcessTemplateAppReducerState, ProcessesUsingTemplateType } from "processTemplates/model/AppState";
import { setEditModeModalOpen, setCreateModalOpen, handleApiError } from "processTemplates/actions/AppActions";
import { ProcessUsingTemplate } from "processTemplates/model/ProcessTemplate";
import { SET_LOADING } from "processTemplates/reducers/AppReducer";
import { getProcessEditLink } from "processTemplates/model/List";

import { getProcessesUsingTemplate } from "./UsedInModal";

const EditModelModal: React.FC = () => {
    const { state, dispatch } = React.useContext<ProcessTemplateAppReducerState>(AppContext);
    const [processesUsingTemplate, setProcessesUsingTemplate] = useState<ProcessUsingTemplate[]>();
    const [processSelectedForEditing, setProcessSelectedForEditing] = useState<Option>();
    const processesToEditSelectOptions = processesUsingTemplate ? processesUsingTemplate.map((p) => ({ label: p.name, value: p.id })) : [];

    useEffect(() => {
        (async () => {
            if (state.editedTemplate) {
                try {
                    dispatch({ type: SET_LOADING, loading: true });
                    const processes = await getProcessesUsingTemplate(state.editedTemplate.id, ProcessesUsingTemplateType.Current);
                    setProcessesUsingTemplate(processes);
                    dispatch({ type: SET_LOADING, loading: false });
                } catch (e) {
                    handleApiError(dispatch, e);
                }
            }
            else {
                setProcessesUsingTemplate(undefined);
                setProcessSelectedForEditing(undefined);
            }
        })();
    }, [state.editedTemplate]);

    const handleClose = () => {
        setEditModeModalOpen(dispatch, undefined);
    };

    const handleCreateNewClick = () => {
        handleClose();
        setCreateModalOpen(dispatch, state.editedTemplate);
    };

    const handleProcessesToEditSelectChange = (newOption: Option) => {
        setProcessSelectedForEditing(newOption);
    }

    const handleEditButtonClick = () => {
        const processUsingTemplate = processesUsingTemplate?.find((p) => p.id === processSelectedForEditing?.value);
        if (processUsingTemplate) {
            const goToHref = getProcessEditLink(processUsingTemplate);
            window.location.replace(goToHref);
        }
    };

    return (
        <CustomModal
            label="template-edit-mode-modal"
            size="smaller"
            onClose={handleClose}
            shouldCloseOnOverlayClick={true}
            show={state.editedTemplate !== undefined}
            modalTitle={<h2>Select Template edit mode</h2>}
        >
            <S.FlexContainer gap={24} asColumn>
                <p style={{ margin: 0 }}>
                    Templates are edited by publishing a Template from a Process. You can either create a new Process or edit an existing Process based on the Template.
                </p>

                <h3>
                    Create new Process from template
                </h3>

                <S.Button onClick={handleCreateNewClick}>
                    Create new
                </S.Button>

                {processesToEditSelectOptions.length > 0 && (
                    <>
                        <h3>
                            Edit existing Process based on the Template
                        </h3>

                        <StyleModalContentLabel style={{ maxWidth: '360px' }}>
                            <span>
                                Select Process to edit
                            </span>
                            <Select
                                id="select-process-based-on-template"
                                classNamePrefix="react-select"
                                placeholder="Select"
                                options={processesToEditSelectOptions}
                                value={processSelectedForEditing}
                                onChange={handleProcessesToEditSelectChange}
                            />
                        </StyleModalContentLabel>

                        <S.Button
                            onClick={handleEditButtonClick}
                            disabled={!processSelectedForEditing}
                        >
                            Edit
                        </S.Button>
                    </>
                )}
            </S.FlexContainer>
        </CustomModal>
    );
};

export const StyleModalContentLabel = styled.label`
    display: grid;
    gap: 4px;

    span {
        font-size: 18px;
        font-family: 'Gilroy-Medium';
    }
`;

export default EditModelModal;